/**
 * @license Angular v15.1.1
 * (c) 2010-2022 Google LLC. https://angular.io/
 * License: MIT
 */

import { ɵ_global, ɵ$localize } from '@angular/localize';
export { ɵ$localize as $localize } from '@angular/localize';

// Attach $localize to the global context, as a side-effect of this module.
ɵ_global.$localize = ɵ$localize;
